export const roomTypeOptions = [
  { value: "ensuite", label: "Ensuite" },
  { value: "studio", label: "Studio" },
  { value: "shared", label: "Shared Room" },
  { value: "private", label: "Private Room" },
  { value: "apartment", label: "Apartment" },
  { value: "non_ensuite", label: "Non-Ensuite" },
  { value: "twin_ensuite", label: "Twin Ensuite" },
  { value: "twin_studio", label: "Twin Studio" },
  { value: "one_bed", label: "1 Bedroom" },
  { value: "two_bed", label: "2 Bedroom" },
  { value: "three_bed", label: "3 Bedroom" },
  { value: "four_bed", label: "4 Bedroom" },
  { value: "five_bed", label: "5 Bedroom" },
  { value: "five_plus_bed", label: "5+ Bedroom" },
  { value: "shared_room", label: "Shared Room" },
  { value: "private_room", label: "Private Room" },
  { value: "entire_place", label: "Entire Place" },
  { value: "twodio", label: "Twodio" },
  { value: "threedio", label: "Threedio" },
  { value: "dorm", label: "Dormitory" },
  { value: "deluxe_ensuite", label: "Deluxe Ensuite" },
  { value: "premium_ensuite", label: "Premium Ensuite" },
  { value: "deluxe_non_ensuite", label: "Deluxe Non-Ensuite" },
  { value: "premium_non_ensuite", label: "Premium Non-Ensuite" },
  { value: "twin_non_ensuite", label: "Twin Non-Ensuite" },
  { value: "lite", label: "Lite" },
  { value: "classic", label: "Classic" },
  { value: "premium", label: "Premium" },
  { value: "deluxe", label: "Deluxe" },
  { value: "accessible", label: "Accessible" },
  { value: "classic_courtyard", label: "Classic Courtyard" },
  { value: "classic_plus", label: "Classic Plus" },
  { value: "premium_plus", label: "Premium Plus" },
  { value: "ultimate_vita", label: "Ultimate Vita" },
  { value: "lite_plus", label: "Lite Plus" },
  { value: "twin_room", label: "Twin Room" },
  { value: "cluster", label: "Cluster" },
  { value: "penthouse", label: "Penthouse" },
  { value: "enhanced", label: "Enhanced" },
  { value: "elite", label: "Elite" },
  { value: "duo", label: "Duo" },
  { value: "essential", label: "Essential" },
  { value: "essential_extra", label: "Essential Extra" },
];

export const levelOfStudyOptions = [
  { value: "UG", label: "UG" },
  { value: "PG", label: "PG" },
  { value: "PhD", label: "PhD" },
  { value: "Non Student", label: "Non Student" },
];

export const BED_TYPE_OPTIONS = [
  { name: "Single Bed", slug: "SINGLE" },
  { name: "Small Double Bed", slug: "SMALL_DOUBLE" },
  { name: "3/4 Double Bed", slug: "TF_DOUBLE" },
  { name: "Double Bed", slug: "DOUBLE" },
  { name: "Queen Size Bed", slug: "QUEEN" },
  { name: "King Size Bed", slug: "KING" },
];

export const KIND_OPTIONS = [
  { name: "Ensuite", slug: "ENSUITE" },
  { name: "Non-Ensuite", slug: "NON_ENSUITE" },
  { name: "Twin-Ensuite", slug: "TWIN_ENSUITE" },
  { name: "Studio", slug: "STUDIO" },
  { name: "Twin-Studio", slug: "TWIN_STUDIO" },
  { name: "One Bed Apartment", slug: "ONE_BED" },
  { name: "Two Bed Apartment", slug: "TWO_BED" },
  { name: "Three Bed Apartment", slug: "THREE_BED" },
  { name: "Four Bed Apartment", slug: "FOUR_BED" },
  { name: "Five Bed Apartment", slug: "FIVE_BED" },
  { name: "More Than Five Bed Apartment", slug: "FIVE_PLUS_BED" },
  { name: "Shared Room", slug: "SHARED_ROOM" },
  { name: "Private Room", slug: "PRIVATE_ROOM" },
  { name: "Entire Place", slug: "ENTIRE_PLACE" },
  { name: "Twodio", slug: "TWODIO" },
  { name: "Threedio", slug: "THREEDIO" },
  { name: "Dorm Room", slug: "DORM" },
];

export const getDurationDisplayValue = (duration: string): string => {
  switch (duration) {
    case "weekly":
      return "week";
    case "monthly":
      return "month";
    case "yearly":
      return "year";
    default:
      return duration;
  }
};

export const getDefaultCurrencySymbol = (
  region?: string,
): string | undefined => {
  if (region === "US") {
    return "$";
  } else if (region === "UK") {
    return "£";
  }
};

export const getDefaultCurrencyUnit = (region?: string): string | undefined => {
  if (region === "US") {
    return "USD";
  } else if (region === "UK") {
    return "GBP";
  }
};

export const getDefaultDurationUnit = (region?: string): string | undefined => {
  if (region === "US") {
    return "month(s)";
  } else if (region === "UK") {
    return "week(s)";
  }
};

export const getDefaultBudgetDuration = (
  region?: string,
): string | undefined => {
  if (region === "US") {
    return "monthly";
  } else if (region === "UK") {
    return "weekly";
  }
};

export const getLeaseDurationUnit = (region?: string): string | undefined => {
  if (region === "US") {
    return "months";
  } else if (region === "UK") {
    return "weeks";
  }
};

export const getTaskLabels = (isVerbafloClient?: boolean) => {
  if (isVerbafloClient) {
    return {
      singular: "Follow Up",
      plural: "Follow Ups",
      addAction: "Add a Follow Up",
      createNew: "Create New Follow Up",
      edit: "Edit Follow Up",
      delete: "Delete Follow Up",
      deleteConfirmation: "Are you sure you want to delete this follow up?",
      schedule: "Schedule your follow up",
      details: "Enter your follow up details",
      detailsPlaceholder: "Add follow up details",
      priority: "Follow up priority",
      assign: "You can assign this follow up to yourself or up to 4 other team members.",
      noItems: "No follow ups added yet",
      noItemsDescription: "Once follow ups are created, you'll see",
      upcoming: "Upcoming Follow Ups",
      completed: "Completed Follow Ups",
      overdue: "Overdue Follow Ups",
      clientNameLabel: "Client Name",
      nameLabel: "Task Name",
      namePlaceholder: "Enter task title",
      descriptionLabel: "Task Description",
      descriptionPlaceholder: "Optional details",
      assigneeLabel: "Assignee Name",
      hasExtendedForm: true as const,
    };
  }
  return {
    singular: "Task",
    plural: "Tasks",
    addAction: "Add a Task",
    createNew: "Create New Task",
    edit: "Edit Task",
    delete: "Delete Task",
    deleteConfirmation: "Are you sure you want to delete this task?",
    schedule: "Schedule your task",
    details: "Enter your task details",
    detailsPlaceholder: "Add task details",
    priority: "Task priority",
    assign: "You can assign this task to yourself or up to 4 other team members.",
    noItems: "No tasks added yet",
    noItemsDescription: "Once tasks are created, you'll see",
    upcoming: "Upcoming Tasks",
    completed: "Completed Tasks",
    overdue: "Overdue Tasks",
    clientNameLabel: "",
    nameLabel: "",
    namePlaceholder: "",
    descriptionLabel: "",
    descriptionPlaceholder: "",
    assigneeLabel: "Assigned to Agent(s)",
    hasExtendedForm: false as const,
  };
};

export const getHelpdeskLabels = (region?: string) => {
  if (region === "US") {
    return {
      section: "Resident Requests",
      allTickets: "All Requests",
      createTicket: "Submit Request",
      ticketSingular: "Request",
      ticketPlural: "Requests",
      ticketSingularLower: "request",
      ticketPluralLower: "requests",
      ticketId: "Request ID",
      ticketCategory: "Request Category",
      ticketSubject: "Request Subject",
      ticketPrefix: "Request",
      ticketStatus: "Request Status",
      ticketDetails: "Request Details",
      ticketDescription: "Request description",
      ticketReports: "Request Reports",
      ticketOwner: "Request Owner",
      paginationUnit: "requests",
      searchPlaceholder: "Search requests",
      noSearchResults: "No requests found",
      deleteTicket: "Delete Request",
      createNewTicket: "Create new request",
      editTicket: "Edit request",
      updateTicketDetails: "Update the request details below",
      createTicketFillDetails: "Fill in the details below to create a new request",
      ticketUpdatedSuccess: "Request updated successfully",
      ticketCreatedSuccess: "Request created successfully",
      failedToUpdateTicket: "Failed to update request",
      failedToCreateTicket: "Failed to create request",
      failedToDeleteTicket: "Failed to delete request",
      ticketDeletedSuccess: "Request deleted successfully",
      assignTicketSubheading: "Assign this request up to 4 users",
      filterByAssignee: "Filter requests by assignee",
      assigneeRequiredTitle: "Assignee required",
      assigneeRequiredMessage:
        "Please assign this request to at least one user before moving it to Closed.",
      ticketDescriptionPlaceholder: "Please provide as much information possible about your request",
      ticketCategoryRequired: "Request category is required",
      ticketSubjectRequired: "Request subject is required",
      ticketsBySystem: "Requests by System",
      closedTicketsPerSite: "Closed Requests per Site",
      closedTicketsPerSiteDescription: "Count of requests which are closed for each site that had raised",
      myTickets: "My Requests",
    };
  }
  return {
    section: "Helpdesk",
    allTickets: "All Tickets",
    createTicket: "Create Ticket",
    ticketSingular: "Ticket",
    ticketPlural: "Tickets",
    ticketSingularLower: "ticket",
    ticketPluralLower: "tickets",
    ticketId: "Ticket ID",
    ticketCategory: "Ticket Category",
    ticketSubject: "Ticket Subject",
    ticketPrefix: "Ticket",
    ticketStatus: "Ticket Status",
    ticketDetails: "Ticket Details",
    ticketDescription: "Ticket description",
    ticketReports: "Ticket Reports",
    ticketOwner: "Ticket Owner",
    paginationUnit: "tickets",
    searchPlaceholder: "Search tickets",
    noSearchResults: "No tickets found",
    deleteTicket: "Delete Ticket",
    createNewTicket: "Create new ticket",
    editTicket: "Edit ticket",
    updateTicketDetails: "Update the ticket details below",
    createTicketFillDetails: "Fill in the details below to create a new ticket",
    ticketUpdatedSuccess: "Ticket updated successfully",
    ticketCreatedSuccess: "Ticket created successfully",
    failedToUpdateTicket: "Failed to update ticket",
    failedToCreateTicket: "Failed to create ticket",
    failedToDeleteTicket: "Failed to delete ticket",
    ticketDeletedSuccess: "Ticket deleted successfully",
    assignTicketSubheading: "Assign this ticket up to 4 users",
    filterByAssignee: "Filter tickets by assignee",
    assigneeRequiredTitle: "Assignee required",
    assigneeRequiredMessage:
      "Please assign this ticket to at least one user before moving it to Closed.",
    ticketDescriptionPlaceholder: "Please provide as much information possible about your ticket",
    ticketCategoryRequired: "Ticket category is required",
    ticketSubjectRequired: "Ticket subject is required",
    ticketsBySystem: "Tickets by System",
    closedTicketsPerSite: "Closed Tickets per Site",
    closedTicketsPerSiteDescription: "Count of tickets which are closed for each site that had raised",
    myTickets: "My Tickets",
  };
};

export const getViewingLabels = (
  region?: string,
  isVerbafloClient?: boolean
) => {
  if (isVerbafloClient) {
    return {
      singular: "Demo",
      plural: "Demos",
      addAction: "Add a Demo",
      schedule: "Schedule Demo",
      virtual: "Virtual Demo",
      type: "Demo Type",
    };
  }
  if (region === "US") {
    return {
      singular: "Tour",
      plural: "Tours",
      addAction: "Add a Tour",
      schedule: "Schedule Tour",
      virtual: "Virtual Tour",
      type: "Tour Type",
    };
  }
  return {
    singular: "Viewing",
    plural: "Viewings",
    addAction: "Add a Viewing",
    schedule: "Schedule Viewing",
    virtual: "Virtual Viewing",
    type: "Viewing Type",
  };
};

type RegionLabelVariant = { UK: string; US: string };

export const REGION_LABEL_CONFIG = {
  // Playground / Knowledge Base
  playground: { UK: "Playground", US: "Knowledge Base" },
  playgroundAccessControl: {
    UK: "Playground Access Control",
    US: "Knowledge Base Access Control",
  },
  playgroundFeature: {
    UK: "Playground feature",
    US: "Knowledge Base feature",
  },
  playgroundAllowedRoles: {
    UK: "Playground Allowed Roles",
    US: "Knowledge Base Allowed Roles",
  },
  knowledgeBaseSection: { UK: "Knowledge Base", US: "Sources" },

  // Enquiry / Inquiry (US spelling)
  justEnquiring: { UK: "Just Enquiring", US: "Just Inquiring" },

  // Viewing / Tour
  viewing: { UK: "Viewing", US: "Tour" },
  viewings: { UK: "Viewings", US: "Tours" },
  viewingRequested: { UK: "Viewing Requested", US: "Tour Requested" },

  // Sales / Leasing
  sales: { UK: "Sales", US: "Leasing" },

  // Ticket / VerbaFlo Support
  ticket: { UK: "Ticket", US: "VerbaFlo Support" },
  ticketManagement: { UK: "Ticket Management", US: "VerbaFlo Support" },
} satisfies Record<string, RegionLabelVariant>;

export type RegionLabelKey = keyof typeof REGION_LABEL_CONFIG;

export const US_CLIENT_CODE = "vfus";

export const getRegionLabel = (
  key: RegionLabelKey,
  clientCode?: string
): string => {
  const variant = REGION_LABEL_CONFIG[key];
  return clientCode === US_CLIENT_CODE ? variant?.US : variant?.UK;
};

export const LEAD_TAG_NAME_OVERRIDES: Array<{
  pattern: RegExp;
  variant: RegionLabelVariant;
}> = [
  { pattern: /\bRebooker\b/g, variant: { UK: "Rebooker", US: "Renewal" } },
  { pattern: /\bViewing\b/g, variant: { UK: "Viewing", US: "Tour" } },
  { pattern: /\bCheck-In\b/g, variant: { UK: "Check-In", US: "Move-In" } },
  { pattern: /\bCheck-in\b/g, variant: { UK: "Check-in", US: "Move-in" } },
];

export const getLeadTagDisplayName = (
  tagName: string | null | undefined,
  clientCode?: string
): string => {
  if (!tagName) return "";
  const isUsClient = clientCode === US_CLIENT_CODE;
  return LEAD_TAG_NAME_OVERRIDES.reduce((acc, { pattern, variant }) => {
    return acc.replace(pattern, isUsClient ? variant.US : variant.UK);
  }, tagName);
};

export const LOST_REASON_NAME_OVERRIDES: Record<string, RegionLabelVariant> = {
  "Just Enquiring": REGION_LABEL_CONFIG.justEnquiring,
};

export const getLostReasonDisplayName = (
  reasonName: string | null | undefined,
  clientCode?: string
): string => {
  if (!reasonName) return "";
  const override = LOST_REASON_NAME_OVERRIDES[reasonName];
  if (!override) return reasonName;
  return clientCode === US_CLIENT_CODE ? override.US : override.UK;
};

export const LEAD_STAGE_NAME_OVERRIDES: Record<string, RegionLabelVariant> = {
  enquired: { UK: "Enquired", US: "New Inquiry" },
};

export const getLeadStageDisplayName = (
  stageName: string | null | undefined,
  clientCode?: string
): string => {
  if (!stageName) return "";
  const override = LEAD_STAGE_NAME_OVERRIDES[stageName.toLowerCase()];
  if (!override) return stageName;
  return clientCode === US_CLIENT_CODE ? override.US : override.UK;
};
